import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL, MOCKUP_IMG, REGULAR_PRICE, TODAY_PRICE } from '../data/product';
const included = ['6 Professional Modules', '250+ Exercises & Movements', '100 Ready-to-Use Sessions', '12 Months of Programming', '5 Premium Bonuses'];
export function PricingCard() {
  return <section id="pricing" className="bg-ink text-white px-4 sm:px-6 py-9 sm:py-12 scroll-mt-4" data-id="element-151" data-mp="2esp55237xi7l">
      <div className="max-w-2xl mx-auto text-center" data-id="element-152" data-mp="29tly5c3oh1wz">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight mb-5" data-id="element-153" data-mp="29vyniabrmek2">
          Everything included.{' '}
          <span className="text-lime" data-id="element-154" data-mp="210iqjkfprja9">One simple price.</span>
        </h2>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer mb-5" data-id="element-155" data-mp="2xj80g8fcjx97">
          <img src={MOCKUP_IMG} alt="Fitness Senior Ready complete visual senior fitness coaching system" className="w-full max-w-[240px] sm:max-w-sm mx-auto object-contain hover:scale-[1.01] transition-transform duration-300 ease-out" data-id="element-156" data-mp="2sqn532gslc3k" />
        </a>

        <div className="bg-white/[0.05] border-2 border-lime/40 rounded-xl p-5 sm:p-7 max-w-sm mx-auto" data-id="element-157" data-mp="2su98qb2y7s2g">
          <h3 className="font-heading font-extrabold uppercase text-base sm:text-xl tracking-tight mb-1.5" data-id="element-158" data-mp="2xrj385572tx5">
            Fitness Senior Ready™
          </h3>
          <p className="font-heading font-semibold uppercase text-[10px] sm:text-xs tracking-[0.12em] text-white/60 leading-snug mb-4" data-id="element-159" data-mp="2otyzmpjv0ljd">
            Complete visual senior fitness coaching system
          </p>

          <ul className="flex flex-col gap-1.5 text-left mb-5 pb-5 border-b border-white/10" data-id="element-160" data-mp="2evjaut8b1od1">
            {included.map(item => <li key={item} className="flex items-center gap-2 text-[11px] sm:text-sm font-semibold text-white/85" data-id="element-161" data-mp="82h49f508f5k">
                <CheckIcon className="w-3.5 h-3.5 text-lime shrink-0" data-id="element-162" data-mp="bn0roreepnzd" />
                {item}
              </li>)}
          </ul>

          <p className="text-[11px] sm:text-sm font-semibold text-white/50 mb-0.5" data-id="element-163" data-mp="1o1t61ncv8q3">
            Regular Price: <span className="line-through" data-id="element-164" data-mp="3tru9wxemk8yb">{REGULAR_PRICE}</span>
          </p>

          <p className="font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.16em] text-lime" data-id="element-165" data-mp="3ttxa2a9hrigr">
            Today:
          </p>
          <p className="font-heading font-black text-3xl sm:text-5xl text-white leading-none mb-2" data-id="element-166" data-mp="pd4b7alwj3l4">
            {TODAY_PRICE}
          </p>

          <p className="inline-block font-heading font-bold text-[10px] uppercase tracking-[0.12em] text-ink bg-gold rounded px-2.5 py-1 mb-4" data-id="element-167" data-mp="kl303s0gziwo">
            Save $54.10
          </p>

          <ul className="flex justify-center gap-4 mb-4" data-id="element-168" data-mp="1d406ihpkggx4">
            <li className="font-heading font-bold uppercase text-[10px] sm:text-xs tracking-wide text-white/85" data-id="element-169" data-mp="18cqitmnkvnnv">
              One-time payment
            </li>
            <li className="font-heading font-bold uppercase text-[10px] sm:text-xs tracking-wide text-white/85" data-id="element-170" data-mp="2r12v0xt6syzt">
              Lifetime access
            </li>
          </ul>

          <CTAButton href={CHECKOUT_URL} data-id="element-171" data-mp="2zz54m1qzkzyp">
            Get Fitness Senior Ready™ Now
          </CTAButton>

          <p className="text-[10px] sm:text-xs font-semibold text-white/50 mt-2.5 tracking-wide" data-id="element-172" data-mp="350kpntt5z6h3">
            Instant Digital Access · Secure Payment · 7-Day Guarantee
          </p>
        </div>
      </div>
    </section>;
}